import { NavigationError } from '@angular/router';

/**
 * Angular's dynamic `import()` for a lazy-loaded route module fails when the hashed chunk file
 * it needs is no longer on the server — which happens any time a new build gets deployed while
 * someone still has the previous bundle loaded in an open tab. This app's hosting rewrites `**`
 * to `/index.html` (firebase.json), so the failed request comes back 200 with HTML instead of a
 * 404, and the browser's module loader rejects it as a MIME-type mismatch rather than a missing
 * file — the wording of that rejection differs per engine (webpack's own ChunkLoadError, plus
 * whatever the browser's native dynamic-import error says), so this matches on name and message
 * across the browsers listed in .browserslistrc: Chrome/Edge, Firefox, Safari.
 *
 * Angular doesn't surface any of this to the user by default: it fires a NavigationError and
 * just stays on the current route, which looks like "clicking anything does nothing / bounces
 * back to dashboard".
 */
export function isStaleChunkNavigationError(event: NavigationError): boolean {
	const error = event.error as { name?: unknown; message?: unknown } | string | undefined;
	const name = typeof error === 'object' && error !== null ? `${error.name ?? ''}` : '';
	const message = typeof error === 'object' && error !== null ? `${error.message ?? ''}` : `${error ?? ''}`;
	const haystack = `${name} ${message}`;

	return /chunkloaderror|loading chunk|failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed/i.test(haystack);
}
